type urlType = `/users${string}`

export const USERS_VERIFY_URL: urlType = "/users/verify"